module.exports = __webpack_public_path__ + "static/showcase@2x-e4961bda2bfab2e4c002584bee89624b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/developers/showcase@2x.png
// module id = 2557
// module chunks = 168707334958949